import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LangProvider } from "@/contexts/LangContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import WhatsAppButton from "@/components/WhatsAppButton";
import Landing from "@/pages/Landing";

function Shell({ children }) {
  return (
    <div className="App grain min-h-screen">
      <Header />
      <div className="pt-16">{children}</div>
      <WhatsAppButton />
    </div>
  );
}

function App() {
  return (
    <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Shell><Landing /></Shell>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster position="top-center" theme="dark" richColors />
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
